(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('EventsManager', EventsManager);

    function EventsManager(lodash, SodLogger, ActionManager, handleActionCall, $q, $rootScope, $injector, $timeout, KeyTrackingService) {
        const registration = [];
        genericListeners();
        return {
            listen: listen,
            isRegistered: isRegistered,
            isRegistedGlobally: isRegistedGlobally,
            destroy: destroy,
            trigger: trigger,
            getRegistrations: function() { return registration},
        };

        function listen(panel, events) {
            // fix empty panel to not run handleRefresh
            // cause when it's destroy, it's still left as empty panel and when it runs
            // if empty panel run after proper panel it could cause listeners = []
            // due to the fact that our function paramaeter for events default to []
            var panelScope = panel.getPanelScope();
            if (panelScope === null) return

            const listeners = [];
            SodLogger.info('The list of events ', events);
            if (events instanceof Array) {
                events.map(function(eventObj) {
                    const refFunc = function (e, eventData) {
                        SodLogger.debug('event triggered', eventObj, e, eventData, panel);
                        // handle sync and async action types separately.
                        if (lodash.has(eventObj, 'delay')) {
                            $timeout(function() {
                                processEventActions(panel, eventObj, e, eventData);
                            }, lodash.get(eventObj,'delay', 0));
                        } else {
                            processEventActions(panel, eventObj, e, eventData);
                        }
                    };

                    if (eventObj.type === 'broadcast') {
                        listeners.push({
                            name: eventObj.event,
                            reference: $rootScope.$on(eventObj.event, refFunc)
                        });
                    } else {
                        listeners.push({
                            name: eventObj.event,
                            reference: panel.getPanelScope().$on(eventObj.event, refFunc)
                        });
                    }
                });

                if (lodash.find(registration, {panelId: panel.getId()})) {
                    destroy(panel.getId());
                }

                registration.push({
                    panelId: panel.getId(),
                    listeners: listeners
                });
            }
        }

        function trigger(panel, event) {
            processEventActions(panel, event, {name: event.event}, null);
        }

        function isRegistered(panelId, eventName) {
            const panelListeners = lodash.find(registration, {panelId: panelId});
            if (!panelListeners) return false;
            return lodash.find(panelListeners.listeners, {name: eventName});
        }

        function isRegistedGlobally(eventName) {
            return registration.reduce(function(carry, _reg) {
                if (carry) return carry;
                return lodash.find(_reg.listeners, {name:eventName});
            }, false);
        }

        function destroy(panelId) {
            const panelListenersIndex = lodash.findIndex(registration, {panelId: panelId});

            if (panelListenersIndex >= 0) {
                const panelListeners = registration[panelListenersIndex];
                for (const listener of panelListeners.listeners) {
                    listener.reference();
                }
                registration.splice(panelListenersIndex, 1);
            }
        }

        function processEventActions(panel, event, evt, evtData) {
            // if (KeyTrackingService.hasNewTabCombinationKeyCode() && !(event.event.indexOf('.new_tab') >= 0)) {
            //     return;
            // }
            const asyncActions = lodash.get(event, 'actions.async', []);
            const syncActions = lodash.get(event, 'actions.sync', []);
            for (const asyncAction of asyncActions) {
                handleAsyncAction(panel, asyncAction, evt, evtData);
            }

            handleSyncAction(panel, syncActions, 0, evt, evtData);
        }

        function handleSyncAction(panel, actions, currentActionIndex, evt, evtData) { // eslint-disable-line no-unused-var
            if (currentActionIndex === actions.length) return;
            const action = actions[currentActionIndex];
            const actionName = lodash.get(action, 'name', false);
            if (!actionName) return;

            const actionOptions = lodash.get(action, 'options', {});
            const actionData = prepareAction(action, panel);
            $q.when(handleActionCall(actionName, actionOptions, actionData, panel, evtData), function(actionResponse) {
                // TODO: TAKE NOTE OF THIS LOGIC: WHEN actionResponse === false end sync;
                const onSuccessName = lodash.get(action, 'onSuccess', 'success');
                const onFailureName = lodash.get(action, 'onFail', false);
                if (actionResponse === false && !onFailureName) {
                    if (lodash.get(actionOptions, 'ignoreResponse', false) === false) {
                        return;
                    }
                }

                const nextEventType =   (actionResponse === false) ? onFailureName : onSuccessName;

                const nextEventName = [evt.name, action.name, nextEventType].join('.');
                let panel_id = panel.getId();
                let broadcast = false;
                if (lodash.has(action, 'options.target_panel')) {
                    panel_id = action.options.target_panel;
                    broadcast = true;
                }
                if (isRegistered(panel_id, nextEventName)) {
                    (broadcast)
                        ? $rootScope.$broadcast(nextEventName, actionResponse ? actionResponse : null)
                        : panel.getPanelScope().$emit(nextEventName, actionResponse ? actionResponse : null);
                } else {
                    handleSyncAction(panel, actions, currentActionIndex + 1, evt, actionResponse || evtData);
                }
            }, function(errorResponse) {
                handleError(errorResponse, panel, action, actionData, evt, evtData);
            });
        }

        function handleAsyncAction(panel, action, evt, evtData) { // eslint-disable-line no-unused-var
            const actionName = lodash.get(action, 'name', false);
            if (!actionName) return;
            const actionOptions = lodash.get(action, 'options', {});
            const actionData = prepareAction(action, panel);
            // Need to be careful with this as not all actions have response. Or should I make them have response.
            // need to prepare the information needed to pass over to the action

            $q.when(handleActionCall(actionName, actionOptions, actionData, panel, evtData), function (actionResponse) {
                // if there are rules from the action, go through it.
                // Async-type handle success responses differently from SyncType. So we can't mix them together.

                const onSuccessName = lodash.get(action, 'onSuccess', 'success');
                const onFailureName = lodash.get(action, 'onFail', false);
                const nextEventType =   (actionResponse === false) ? onFailureName : onSuccessName;
                const nextEventName = [evt.name, action.name, nextEventType].join('.');
                if (isRegistered(panel.getId(), nextEventName)) {
                    panel.getPanelScope().$emit(nextEventName, actionResponse ? actionResponse : null);
                }

                // call success event.
            }, function(errorResponse) {
                handleError(errorResponse, panel, action, actionData, evt, evtData);
            });
        }

        function handleError(errorActionResponse, panel, action, actionData, evt, evtData) {
            // if errorAction has statusCode, look through status code stuff.
            // Similarly, Async-type handle error responses differently from SyncType.
            const errorObject = {
                response: errorActionResponse.data,
                panel,
                action,
                actionData,
                evt,
                evtData
            };

            const statusCode = lodash.get(errorActionResponse, 'status', null);
            if (!statusCode) {
                SodLogger.debug('Action Error Response of: ' + action.name, errorObject);
                handleErrorTrigger(panel, evt.name, action.name, 'error', errorObject);
            }
            if (statusCode) {
                switch (statusCode) {
                    case 422:
                        // call validation event if have, otherwise call generic validation event
                        handleErrorTrigger(panel, evt.name, action.name, 'validation', errorObject);
                        break;
                    case 403:
                        handleErrorTrigger(panel, evt.name, action.name, 'unauthorized', errorObject);
                        break;
                    default:
                        // call error event if have, otherwise call generic error event
                        handleErrorTrigger(panel, evt.name, action.name, 'error', errorObject);
                        break;
                }
            }
        }

        function handleErrorTrigger(panel, eventName, actionName, type, errorObj) {
            let isRmsEventNameRegistered = false;
            let nextRmsEventName;
            if (lodash.has(errorObj, 'response.rms_error_code')) {
                nextRmsEventName = [eventName, actionName, type, errorObj.response.rms_error_code].join('.');
                isRmsEventNameRegistered = isRegistered(panel.getId(), nextRmsEventName);
            }

            if (isRmsEventNameRegistered) {
                panel.getPanelScope().$emit(nextRmsEventName, errorObj);
            } else {
                const nextEventName = [eventName, actionName, type].join('.');
                const _isRegistered = isRegistered(panel.getId(), nextEventName);
                if (_isRegistered) {
                    panel.getPanelScope().$emit(nextEventName, errorObj);
                }
                if (!_isRegistered) {
                    const _isGloballyRegistered = isRegistedGlobally(nextEventName);
                    if (_isGloballyRegistered) {
                        $rootScope.$broadcast(nextEventName, errorObj);
                    } else {
                        panel.getPanelScope().$emit('action-manager.generic.' + type, errorObj);
                    }
                }
            }
        }

        function prepareAction(action, panel) {
            let actionData = {};

            const stateKey = lodash.get(action, 'stateMap.key', false);
            if (stateKey) {
                const defaultState = lodash.get(action, 'stateMap.defaultState', {});
                actionData = panel.getState(stateKey, defaultState);
                // if action.has('stateMutate'), call ActionData.mutate. Function and service not create at this point.
            }

            const stateWrapper = lodash.get(action, 'stateMap.wrapper', false);
            if (stateWrapper) {
                actionData = lodash.set({}, stateWrapper, actionData);
            }


            if (lodash.has(action, 'appendModel')) {
                lodash.forIn(action.appendModel, function(value, key) {
                    lodash.set(actionData, key, value);
                });
            }

            return actionData;
        }

        function genericListeners() {
            $rootScope.$on('action-manager.generic.validation', function(e, data) {
                SodLogger.info('action-manager.generic.validation triggered', e, data);
                // Todo: quickfix for now, until fully implements
                var FormBuilderService = $injector.get('FormBuilderService');
                var fbService = FormBuilderService.get(data.evtData.formIdentifier);
                fbService.elementsService.setValidationRules(data.response.rules, data.response.summary);
                // ActionManager('enable-button', data.evtData.targetScope.name);
                ActionManager('enable-button', {
                    enable_all_disabled: true
                });
            });
            $rootScope.$on('action-manager.generic.error', function(e, eventData) {
                SodLogger.warn('action-manager.generic.error triggered', e, eventData);
            });
        }
    }
})();